import { Utility } from "./utility";
var io = require("socket.io-client");
var url = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

export class WebSocket{
    private static callbackArray: { (string): void}[] = [];
    private socket = io.connect(url);
    private static parsedData;

    public Start(){
        let district: string =  Utility.getQueryVariable("district");
        let station: string =  Utility.getQueryVariable("station");

        if(district == null){
            district = "all";
        }

        if(station == null){
            station = "all";
        }

        this.socket.on("connect", function() {
            console.log("Websocket connected");
            this.emit("subscribe", {district: district, station: station});
        });

        this.socket.on("update", (data) => WebSocket.Update(data));
    }

    public static OnUpdate(callback){
        WebSocket.callbackArray.push(callback);
    }

    public static Update(data){
        if(data != null)
        {
            WebSocket.parsedData = JSON.parse(JSON.parse(data));
        }
        WebSocket.callbackArray.forEach(function(callback){
            callback(WebSocket.parsedData);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/websocket.ts